import React from 'react';

/**
 * Screen-only actions for the report. The toolbar container uses .no-print so it never
 * appears in browser Print / Save as PDF output.
 */
export default function NumerologyReportToolbar() {
  return (
    <div className="amm-num-report-toolbar no-print">
      <button type="button" className="amm-num-btn-print" onClick={() => window.print()}>
        Print / Save as PDF
      </button>
    </div>
  );
}
